"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessPluginQueueSchema = exports.ServicePluginQueueSchema = exports.QueueSchema = void 0;
const zod_1 = require("zod");
const credential_1 = require("../misc/credential");
//going to obsolete QueueSchema
exports.QueueSchema = zod_1.z.object({
    pluginId: zod_1.z.string(),
    schedule: zod_1.z.string(),
    keyId: zod_1.z.string(),
    credential: credential_1.CredentialSchema,
    lastTriggered: zod_1.z.string().nullable(),
    businessId: zod_1.z.string(),
    userId: zod_1.z.string().optional(),
    createdAt: zod_1.z.string()
});
exports.ServicePluginQueueSchema = zod_1.z.object({
    pluginId: zod_1.z.string(),
    schedule: zod_1.z.string(),
    keyId: zod_1.z.string(),
    credential: credential_1.CredentialSchema,
    lastTriggered: zod_1.z.string().nullable(),
    businessId: zod_1.z.array(zod_1.z.string()),
    userId: zod_1.z.array(zod_1.z.string()).optional(),
    createdAt: zod_1.z.string()
});
exports.BusinessPluginQueueSchema = zod_1.z.object({
    pluginId: zod_1.z.string(),
    schedule: zod_1.z.string(),
    keyId: zod_1.z.string(),
    credential: credential_1.CredentialSchema,
    lastTriggered: zod_1.z.string().nullable(),
    businessId: zod_1.z.string(),
    userId: zod_1.z.string().optional(),
    createdAt: zod_1.z.string()
});
